const corporate_history = () => {
	const history = document.querySelector('.p-corporate-history__sec');
	if(history !== null && window.innerWidth < 768){
		const head = document.querySelectorAll('.p-corporate-history__sec__head');
		for (let i = 0; i < head.length; i++) {
			head[i].addEventListener('click', () => {
				head[i].classList.toggle('is-open');
				slide_toggle(head[i].nextElementSibling, 800);
			});
			
		}

	}
}